export const DASHBOARD_URL = Object.freeze({
  INITIATE :`/dashboard/initiate`,
  MAPPING_LIST:function mappinglist(page,limit,order){
              return(`/dashboard/list?page=${page}&limit=${limit}&order=${order}`)},
})